"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var test_directive_html_1 = __importDefault(require("./test-directive.html"));
require("./test.less");
(function (module) {
    module.component('prTestComponent', {
        bindings: {
            textModel: '=',
            textChange: '&'
        },
        templateUrl: test_directive_html_1.default
    });
})(angular.module('qualtrics.pr'));
